import modalSignup from '~/mixins/modalSignup.js'
import signupIframe from '~/components/Molecules/OrganicSquad/SignupIframe/SignupIframe.vue'
import stripe from '~/mixins/stripe.js'

export default {
  mixins: [modalSignup, stripe],

  props: {
    logo: {
      type: Object,
    },

    tag: {
      type: Object,
    },

    title: {
      type: Object,
    },

    body: {
      type: String,
    },

    button: {
      type: Object,
    },

    image: {
      type: Object,
    },

    reverse: {
      type: Boolean,
      default: false,
    },

    background: {
      type: Boolean,
      default: false,
    },

    center: {
      type: Boolean,
      default: false,
    },

    fullHeight: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    signupIframe,
  },

  computed: {
    hasBackground() {
      return this.background ? 'with-background' : false
    },

    isCenter() {
      return this.center ? 'center' : false
    },

    isReverse() {
      return this.reverse ? 'reverse' : false
    },

    isFullHeight() {
      return this.fullHeight ? 'fullHeight' : false
    },

    withoutImage() {
      return this.image ? false : 'without-image'
    },

    hasLogo() {
      return this.logo ? true : false
    },

    hasTag() {
      return this.tag ? true : false
    },

    hasTitle() {
      return this.title ? true : false
    },

    hasBody() {
      return this.body ? true : false
    },

    hasButton() {
      return this.button ? true : false
    },

    hasImage() {
      return this.image ? true : false
    },
  },
}
